module.exports = __webpack_public_path__ + "img/aham-wp-logo-white.93b04fb4.svg";